import {createSelector} from 'reselect';

const selectTnc = (state) => state.tnc;

const selectTncPopupList = createSelector(selectTnc, (state) => state.tncPopupsList);

const selectIsTncPopupVisible = createSelector(selectTncPopupList, (tncPopupsList) => tncPopupsList?.length > 0);

export {selectIsTncPopupVisible, selectTncPopupList};
